<template>
  <div class="sellCenterBox">
    <LinkTitle></LinkTitle>
    <!-- <div class = "sellCenterMenuWrap">
        <div v-for = "(item,index) in menuData" @click = "item.fn(item)" :key = "index">{{item.title}}</div>
      </div> -->
    <div ref="contentWrap" :style="conheight" class="contentWrap">
      <div class="menuWrap">
        <div
          :class="['menuItem']"
          :key="index"
          :ref="'menuItem' + index"
          @click="(e) => selectItem(e, index)"
          v-for="(item, index) in allRoleMenuData"
        >
          <i :class="item.icon || 'el-icon-check'"></i
          ><span class="itemName">{{ item.title }}</span
          ><span class="rightBox" :ref="'rightBox' + index"
            ><i class="el-icon-arrow-down"></i
          ></span>
        </div>
        <!-- <div>商品管理</div>
          <div>销售订单</div>
          <div>采购订单</div>
          <div>财务管理</div>
          <div>员工管理</div> -->
      </div>
      <div :style="conheight" class="rightPage">
        <router-view :height="conheight.height"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAuthRoleUrl } from "@/api/api";

// 0:"管理员",
// 1:"库管员",
// 2:"销售员",
// 3:"财务会计",
// 4:"普通员工",
// 5:"出纳",
// 6:"采购员",
const allRoleMenuList = {
  0: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  1: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  2: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  3: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  4: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  5: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
  6: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
};

export default {
  data() {
    return {
      conheight: {
        height: "",
      },
      menuData: [],
      newMenuData: [],
      allRoleMenuData: [
        {
          title: "白条仓库",
          fn: this.warehouseClick,
          index: 0,
          page: "whitebar",
          icon: "el-icon-house",
        },
        {
          title: "商品管理",
          fn: this.productClick,
          index: 1,
          page: "myCommodity",
          icon: "el-icon-goods",
        },
        {
          title: "销售订单",
          fn: this.toStoreSellOrder,
          index: 2,
          page: "storeSellOrder",
          icon: "el-icon-tickets",
        },
        {
          title: "采购订单",
          fn: this.toStoreBuyOrder,
          index: 3,
          page: "storeBuyOrder",
          icon: "el-icon-mobile",
        },
        {
          title: "财务管理",
          fn: this.toMoneyManage,
          page: "moneyManage,storeWallateRecharge,storeWithdrawal",
          index: 4,
          icon: "el-icon-coin",
        },
        {
          title: "员工管理",
          fn: this.staffPageClick,
          index: 5,
          page: "staffPage,roleSetting,addStaff",
          icon: "el-icon-s-custom",
        },
        {
          title: "客户管理",
          fn: this.customeManage,
          page: "customeManage,customeSetting,addCustome",
          index: 6,
          icon: "el-icon-phone",
        },
        {
          title: "优惠管理",
          fn: this.discountClick,
          index: 7,
          page: "discountManage,discountSetting,addDiscount",
          icon: "el-icon-s-custom",
        },
        // {
        //   title: "卡包管理",
        //   fn: this.productClick,
        //   index: 7,
        //   icon: "el-icon-wallet",
        // },
        // {
        //   title: "通知消息",
        //   fn: this.productClick,
        //   index: 8,
        //   icon: "el-icon-chat-dot-square",
        // },
        // {
        //   title: "评价管理",
        //   fn: this.productClick,
        //   index: 9,
        //   icon: "el-icon-chat-square",
        // },
        // {
        //   title: "统计分析",
        //   fn: this.productClick,
        //   index: 10,
        //   icon: "el-icon-pie-chart",
        // },
        // {
        //   title: "白条优选",
        //   fn: this.productClick,
        //   index: 11,
        //   icon: "el-icon-chicken",
        // },
        // {
        //   title: "预购管理",
        //   fn: this.orderManage,
        //   index: 12,
        //   icon: "el-icon-shopping-cart-1",
        // },
        // {
        //   title: "买单管理",
        //   fn: this.productClick,
        //   index: 13,
        //   icon: "el-icon-sold-out",
        // },
        // {
        //   title: "卖单管理",
        //   fn: this.productClick,
        //   index: 14,
        //   icon: "el-icon-sell",
        // },
        // {
        //   title: "定向管理",
        //   fn: this.productClick,
        //   index: 15,
        //   icon: "el-icon-position",
        // },
        // {
        //   title: "结算中心",
        //   fn: this.productClick,
        //   index: 16,
        //   icon: "el-icon-money",
        // },
        // {
        //   title: "自营屠宰",
        //   fn: this.productClick,
        //   index: 17,
        //   icon: "el-icon-crop",
        // },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  mounted() {
    this.getUserRoleDate();
    this.setHeight();
    window.addEventListener("resize", this.setHeight);
    this.setLeftMainSelect();
    this.checkStoreType();
  },
  methods: {
    checkStoreType() {
      if (this.companyInfo && this.companyInfo.type == 2) {
        this.allRoleMenuData = [
          ...this.allRoleMenuData,
          {
            title: "结算中心",
            fn: this.moneyCalculeteClick,
            index: 7,
            page: "moneyCalculete,upLoadThing",
            icon: "el-icon-wallet",
          },
        ];
      }
    },
    toMoneyManage() {
      this.$router.push("moneyManage");
    },

    toStoreSellOrder() {
      this.$router.push("storeSellOrder");
    },
    setLeftMainSelect() {
      let current = this.allRoleMenuData.filter((item, i) => {
        if (item.page) {
          return item.page.indexOf(this.$route.name) > -1;
        } else {
          return false;
        }
      });
      console.log("current", current);
      this.$refs["menuItem" + current[0].index][0].classList.add("checked");
    },
    setHeight() {
      let conheight = window.innerHeight - 70;
      if (conheight < 560) {
        conheight = 560;
      }
      this.conheight.height = conheight + "px";
      // this.conheight.height = window.innerHeight - 70 + "px";
    },
    getUserRoleDate() {
      let { storeId, access_token } = this.userInfo;
      let that = this;
      console.log(this.allRoleMenuData, 22);
      if (!access_token || !storeId) {
        that.$message({
          message: "用户信息无效",
          // type: "warning",
        });
        return;
      }
      let data = {
        access_token: access_token,
        store_id: storeId,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({ method: "post", data: param, url: getAuthRoleUrl })
        .then(function (res) {
          console.log("角色", res);
          if (res.data.resultCode == 1) {
            that.initMenuData(res.data.data);
          } else {
            that.$message({
              message: res.data.resultMsg,
              center: true,
              type: "error",
            });
          }
        })
        .catch((error) => {
          that.$message({
            message: error,
            center: true,
            type: "error",
          });
        });
    },
    selectItem(e, index) {
      // console.log(e.target);
      // console.log(index);

      let allItemRight = document.getElementsByClassName("rightBox");
      allItemRight = Array.from(allItemRight);
      allItemRight.forEach((item) => {
        item.classList.remove("checkedRightBox");
      });
      this.$refs["rightBox" + index][0].classList.add("checkedRightBox");

      let menuItem = document.getElementsByClassName("menuItem");
      menuItem = Array.from(menuItem);
      menuItem.forEach((item) => {
        item.classList.remove("checked");
      });
      this.$refs["menuItem" + index][0].classList.add("checked");

      this.allRoleMenuData[index].fn();
    },
    initMenuData(roleDate) {
      let roleStr = allRoleMenuList[roleDate];
      if (!roleStr) {
        return;
      }
      this.menuData = this.allRoleMenuData.filter((item, index) => {
        return roleStr.split(",").indexOf(item.index.toString()) > -1;
      });
    },
    productClick(item) {
      console.log(item, "点击数据");
      this.$router.push({
        name: "myCommodity",
      });
    },
    toStoreBuyOrder() {
      this.$router.push({
        name: "storeBuyOrder",
      });
    },
    warehouseClick() {
      this.$router.push({
        name: "whitebar",
      });
    },
    staffPageClick() {
      this.$router.push({
        name: "staffPage",
      });
    },
    discountClick() {
      this.$router.push({
        name: "discountManage",
      });
    },
    customeManage() {
      this.$router.push({
        name: "customeManage",
      });
    },
    moneyCalculeteClick() {
      this.$router.push({
        name: "moneyCalculete",
      });
    },
    orderManage() {
      this.$router.push({
        name: "orderManage",
      });
    },
  },
};
</script>

<style scoped lang='less'>
.sellCenterBox {
  position: relative;
}
.sellCenterMenuWrap {
  width: 90%;
  margin: 50px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  div {
    width: 100px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #3290f0;
    color: #fff;
    margin: 10px 20px;
    border-radius: 10px;
  }
}

.contentWrap {
  width: 95%;
  margin: 20px auto;

  flex: 1;
  display: flex;
}
.menuWrap {
  width: 160px;
  display: flex;
  flex-direction: column;
  background-color: #009e96;
  margin-right: 10px;
  text-align: center;
  color: #fff;
  .menuItem {
    width: 160px;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    border-bottom: 1px solid #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    i {
      line-height: 30px;
    }
  }
  .menuItem:hover {
    cursor: pointer;
    color: red;
  }
}
.itemName {
  // background-color: blue;
  margin: 0 10px;
}
.rightBox {
  transition: all 0.5s linear 0;
  transform: rotate(0);
}
.checkedRightBox {
  transform: rotate(-90deg);
}
.checked {
  background-color: #b2cecb;
}
.rightPage {
  background-color: #f1f1f1;
  width: 100%;
  /* // overflow: scroll; */
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/SellCenter.vue